import React from 'react';

const Support: React.FC = () => {
  return (
    <div className="flex flex-col w-full h-full ">
      <h1 className="font-semibold text-xl mb-20">
        Support for the Cloudlistings Application
      </h1>
      <div className="flex flex-col w-full h-32 justify-center justify-items-center bg-white shadow rounded-lg overflow-hidden">
        <p className=" justify-items-center text-xl text-gray-800 text-center animate-bounce">
          Coming Soon! Page currently under construction
        </p>
      </div>
    </div>
  );
};

export default Support;
